var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StatusValues } from '../../constants/transportToWarehouseValues';
import { decamelize } from '../../utils/camelize';
import { Box, Stepper, Step, StepLabel } from '@mui/material';
import { blue } from '@mui/material/colors';
var StyledStep = styled(Step)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:first-child {\n    padding-left: 0px;\n  }\n\n  width: 70px;\n\n  .Mui-active {\n    color: ", ";\n  }\n"], ["\n  &:first-child {\n    padding-left: 0px;\n  }\n\n  width: 70px;\n\n  .Mui-active {\n    color: ", ";\n  }\n"])), blue[500]);
var TransportToWarehouseStatus = function (_a) {
    var transportToWarehouseStatus = _a.transportToWarehouseStatus;
    var t = useTranslation().t;
    var statuses = t('params.transportToWarehouse.statuses', { returnObjects: true });
    var statusLabels = Object.fromEntries(Object.entries(__assign({}, statuses)).map(function (_a) {
        var k = _a[0], v = _a[1];
        return [decamelize(k), v];
    }));
    var transportToWarehouseStatusIndex = StatusValues.indexOf(transportToWarehouseStatus);
    return (React.createElement(Box, { maxWidth: 480 },
        React.createElement(Stepper, { activeStep: transportToWarehouseStatusIndex, alternativeLabel: true }, Object.keys(statusLabels).map(function (key, index) { return (React.createElement(StyledStep, { key: index, completed: index < transportToWarehouseStatusIndex ||
                transportToWarehouseStatus === 'warehousing' },
            React.createElement(StepLabel, null, statusLabels[key]))); }))));
};
export default TransportToWarehouseStatus;
var templateObject_1;
